/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeInventoryEmptyDto,
  ApiEnvelopeItemEntryListResponse,
  ApiEnvelopeItemEntryResponse,
  ItemEntry,
  ItemEntryPostRequest,
  PriceType
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type itemEntryPostItemEntryResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type itemEntryPostItemEntryResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type itemEntryPostItemEntryResponseSuccess = (itemEntryPostItemEntryResponse200) & {
  headers: Headers;
};
export type itemEntryPostItemEntryResponseError = (itemEntryPostItemEntryResponse400) & {
  headers: Headers;
};

export type itemEntryPostItemEntryResponse = (itemEntryPostItemEntryResponseSuccess | itemEntryPostItemEntryResponseError)

export const getItemEntryPostItemEntryUrl = () => {




  return `/api/ItemEntry`
}

export const useItemEntryPostItemEntryHook = (): (itemEntryPostRequest?: ItemEntryPostRequest, options?: RequestInit) => Promise<itemEntryPostItemEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (itemEntryPostRequest?: ItemEntryPostRequest, options?: RequestInit) => {

        return customFetcher(getItemEntryPostItemEntryUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(itemEntryPostRequest)
  }
);
      }
  }


export type itemEntryPutItemEntryResponse200 = {
  data: ApiEnvelopeItemEntryResponse
  status: 200
}

export type itemEntryPutItemEntryResponse400 = {
  data: ApiEnvelopeItemEntryResponse
  status: 400
}

export type itemEntryPutItemEntryResponseSuccess = (itemEntryPutItemEntryResponse200) & {
  headers: Headers;
};
export type itemEntryPutItemEntryResponseError = (itemEntryPutItemEntryResponse400) & {
  headers: Headers;
};

export type itemEntryPutItemEntryResponse = (itemEntryPutItemEntryResponseSuccess | itemEntryPutItemEntryResponseError)

export const getItemEntryPutItemEntryUrl = () => {




  return `/api/ItemEntry`
}

export const useItemEntryPutItemEntryHook = (): (itemEntry?: ItemEntry, options?: RequestInit) => Promise<itemEntryPutItemEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (itemEntry?: ItemEntry, options?: RequestInit) => {

        return customFetcher(getItemEntryPutItemEntryUrl(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(itemEntry)
  }
);
      }
  }


export type itemEntryGetItemEntriesResponse200 = {
  data: ApiEnvelopeItemEntryListResponse
  status: 200
}

export type itemEntryGetItemEntriesResponseSuccess = (itemEntryGetItemEntriesResponse200) & {
  headers: Headers;
};
;

export type itemEntryGetItemEntriesResponse = (itemEntryGetItemEntriesResponseSuccess)

export const getItemEntryGetItemEntriesUrl = () => {




  return `/api/ItemEntry`
}

export const useItemEntryGetItemEntriesHook = (): ( options?: RequestInit) => Promise<itemEntryGetItemEntriesResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getItemEntryGetItemEntriesUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type itemEntryDeleteItemEntryResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type itemEntryDeleteItemEntryResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type itemEntryDeleteItemEntryResponseSuccess = (itemEntryDeleteItemEntryResponse200) & {
  headers: Headers;
};
export type itemEntryDeleteItemEntryResponseError = (itemEntryDeleteItemEntryResponse400) & {
  headers: Headers;
};

export type itemEntryDeleteItemEntryResponse = (itemEntryDeleteItemEntryResponseSuccess | itemEntryDeleteItemEntryResponseError)

export const getItemEntryDeleteItemEntryUrl = (id: string,) => {




  return `/api/ItemEntry/${id}`
}

export const useItemEntryDeleteItemEntryHook = (): (id: string, options?: RequestInit) => Promise<itemEntryDeleteItemEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getItemEntryDeleteItemEntryUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type itemEntryGetItemEntryResponse200 = {
  data: ApiEnvelopeItemEntryResponse
  status: 200
}

export type itemEntryGetItemEntryResponse400 = {
  data: ApiEnvelopeItemEntryResponse
  status: 400
}

export type itemEntryGetItemEntryResponseSuccess = (itemEntryGetItemEntryResponse200) & {
  headers: Headers;
};
export type itemEntryGetItemEntryResponseError = (itemEntryGetItemEntryResponse400) & {
  headers: Headers;
};

export type itemEntryGetItemEntryResponse = (itemEntryGetItemEntryResponseSuccess | itemEntryGetItemEntryResponseError)

export const getItemEntryGetItemEntryUrl = (id: string,) => {




  return `/api/ItemEntry/${id}`
}

export const useItemEntryGetItemEntryHook = (): (id: string, options?: RequestInit) => Promise<itemEntryGetItemEntryResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getItemEntryGetItemEntryUrl(id),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type itemEntryAdjustPriceResponse200 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 200
}

export type itemEntryAdjustPriceResponse400 = {
  data: ApiEnvelopeInventoryEmptyDto
  status: 400
}

export type itemEntryAdjustPriceResponseSuccess = (itemEntryAdjustPriceResponse200) & {
  headers: Headers;
};
export type itemEntryAdjustPriceResponseError = (itemEntryAdjustPriceResponse400) & {
  headers: Headers;
};

export type itemEntryAdjustPriceResponse = (itemEntryAdjustPriceResponseSuccess | itemEntryAdjustPriceResponseError)

export const getItemEntryAdjustPriceUrl = (id: string,
    price: number,
    type: PriceType,) => {




  return `/api/ItemEntry/${id}/adjust/${price}/${type}`
}

export const useItemEntryAdjustPriceHook = (): (id: string,
    price: number,
    type: PriceType, options?: RequestInit) => Promise<itemEntryAdjustPriceResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    price: number,
    type: PriceType, options?: RequestInit) => {

        return customFetcher(getItemEntryAdjustPriceUrl(id,price,type),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


